// extracted by mini-css-extract-plugin
module.exports = {"percentWithTrend":"groupsTableCells_percentWithTrend__3yLD5"};